import { RootState } from "@/store/store";
import { ResourceType } from "@/services/cloudchipr.api";
import { getFirstParentInHierarchyResourceType } from "@/utils/helpers/resources/getFirstParentInHierarchyResourceType";
import { postUsersMeV2OrganisationsCurrentByTypeResourcesSelector } from "@/store/resources-grid/selectors/resource-data/postUsersMeV2OrganisationsCurrentByTypeResourcesSelector";

export const liveFilteredResourcesEmsPriceSelector = (
  state: RootState,
  resourceType: ResourceType,
): number | null => {
  const data = postUsersMeV2OrganisationsCurrentByTypeResourcesSelector(
    getFirstParentInHierarchyResourceType(resourceType) ?? resourceType,
  )(state)?.data;

  return data?.estimated_monthly_waste ?? null;
};
